import { FC, useState } from "react"
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { syncDO } from "src/services/fetcher"
import swal from 'sweetalert'

interface Props {
    showSync?: boolean
    setShowSync: (value: boolean) => void
    isLoadingSync?: boolean
    setIsLoadingSync: (value: boolean) => void
}

export const ModalSync: FC<Props> = ({
    showSync,
    setShowSync,
    isLoadingSync,
    setIsLoadingSync
}) => {
    const {t} = useTranslation()

    const [soNumber, setSoNumber] = useState('')
    const [createdAt, setCreatedAt] = useState('')

    const doSync = async () => {
        setIsLoadingSync(true)
        try{
            await syncDO({
                so_number: soNumber,
                do_date: createdAt
            })

            swal({
                title: 'Success',
                text: t('Synchronize') + ' ' + t('berhasil'),
                icon: 'success'
            })
        }catch(e: any) {
            swal({
                title: 'Error',
                text: e?.response?.data?.message || e?.message,
                icon: 'error'
            })
        }
        setIsLoadingSync(false)
    }

    return <>
        <Modal
            show={showSync}
            onHide={() => setShowSync(false)}
            centered
            backdrop='static'
        >
            <Modal.Header className="text-white" closeButton>Sync DO</Modal.Header>
            <Modal.Body>
                <Row className='mb-3'>
                    <Col md={5}>
                        <p className='fs-4 mt-2'>{t('MANAGEMENT_DO_TABLE.COL_SO_NUMBER')}</p>
                    </Col>
                    <Col md={7}>
                        <Form.Control type='text' defaultValue={soNumber} size='sm' onChange={(e: any) => {
                            setSoNumber(e?.target?.value)
                        }}/>
                    </Col>
                </Row>
                <Row className='mb-3'>
                    <Col md={5}>
                        <p className='fs-4 mt-2'>{t('tanggal-buat')}</p>
                    </Col>
                    <Col md={7}>
                        <Form.Control type='date' defaultValue={createdAt} size='sm' onChange={(e: any) => {
                            setCreatedAt(e?.target?.value)
                        }}/>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={() => setShowSync(false)}>
                    {t('order-tutup')}
                </Button>
                <Button variant='primary' onClick={doSync} disabled={isLoadingSync}>
                    {isLoadingSync ? (
                        <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                        'Sync'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}